module.exports = __webpack_public_path__ + "img/icon-certificate.6820f9ee.svg";